/**
 * Social Authentication API Service
 * Handles Google and Facebook OAuth
 */

import apiClient from './axios';
import { ApiResponse } from './types';

export interface SocialAuthResponse {
  auth_url: string;
}

export const socialAuthApi = {
  /**
   * Get Google OAuth redirect URL
   */
  getGoogleAuthUrl: async (): Promise<SocialAuthResponse> => {
    const response = await apiClient.get('/auth/google/redirect');
    // Backend returns { auth_url: "..." } directly (axios wraps in response.data)
    const responseData = response.data;
    
    // Check direct auth_url first (most common case)
    if (responseData?.auth_url) {
      return { auth_url: responseData.auth_url };
    }
    
    // Check if wrapped in data property (for consistency with other endpoints)
    if (responseData?.data?.auth_url) {
      return { auth_url: responseData.data.auth_url };
    }
    
    throw new Error('Invalid response format: auth_url not found');
  },

  /**
   * Get Facebook OAuth redirect URL
   */
  getFacebookAuthUrl: async (): Promise<SocialAuthResponse> => {
    const response = await apiClient.get('/auth/facebook/redirect');
    // Backend returns { auth_url: "..." } directly (axios wraps in response.data)
    const responseData = response.data;
    
    // Check direct auth_url first (most common case)
    if (responseData?.auth_url) {
      return { auth_url: responseData.auth_url };
    }
    
    // Check if wrapped in data property (for consistency with other endpoints)
    if (responseData?.data?.auth_url) {
      return { auth_url: responseData.data.auth_url };
    }
    
    throw new Error('Invalid response format: auth_url not found');
  },
};

